import React from 'react';
import { Row, Button } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { PlusOutlined } from '@ant-design/icons';
import { GET_BUDGETS } from '../../../../../gql/budgets';
import BudgetsTable from './BudgetsTable';
import BudgetHeaderCotent from '../../components/BudgetHeaderCotent';
import PrivateComponentInProject from '../../../../auth/PrivateComponentInProject';
import useProjectFrozen from 'hooks/useProjectFrozen';

const Budgets = () => {
  const { projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const { data, loading } = useQuery(GET_BUDGETS, {
    variables: {
      projectIds: [projectId],
    },
  });

  const budgets = data?.budgets;

  return (
    <PageContainer
      loading={loading}
      header={{ title: 'Budgets' }}
      ghost
      style={{ marginBottom: '32px' }}
      content={<BudgetHeaderCotent />}
    >
      {!projectFrozen && (
        <PrivateComponentInProject expectedScopeType={['WRITE_BUDGET']}>
          <Row style={{ marginBottom: '16px' }}>
            <Link to={`/projects/${projectId}/budget-virement/budgets/add`}>
              <Button type="primary" icon={<PlusOutlined />}>
                Add Budget
              </Button>
            </Link>
          </Row>
        </PrivateComponentInProject>
      )}
      <BudgetsTable budgets={budgets} />
    </PageContainer>
  );
};

export default Budgets;
